// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InputParameterBase } from './InputParameterBase';
import { InputParameterType } from './InputParameterEnum';
export class InputParameterCombobox extends InputParameterBase {
    constructor(variableName = 'Empty', comment = '', inputNumber = 0, variants = []) {
        super(variableName, InputParameterType.COMBOBOX, comment, inputNumber);
        this.Variants = variants;
    }
}
